// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  font-size: 13px;
}
@media (min-width: 48em) {
  :root {
    font-size: 14px;
  }
}
@media (min-width: 62em) {
  :root {
    font-size: 14.5px;
  }
}
@media (min-width: 80em) {
  :root {
    font-size: 15px;
  }
}
@media (min-width: 96em) {
  :root {
    font-size: 16px;
  }
}

html {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
}

@keyframes mbf-sweep {
  from {
    transform: translateX(-48px);
  }
  to {
    transform: translateX(160px);
  }
}
@keyframes mbf-breathe {
  0%, 100% {
    transform: scale(0.98);
    opacity: 0.85;
  }
  50% {
    transform: scale(1.02);
    opacity: 1;
  }
}
@keyframes mbf-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(var(--mbf-pulse-rgb, 107, 191, 89), 0.45);
  }
  100% {
    box-shadow: 0 0 0 6px rgba(var(--mbf-pulse-rgb, 107, 191, 89), 0);
  }
}
@keyframes mbf-shimmer {
  from {
    background-position: -200% 0;
  }
  to {
    background-position: 200% 0;
  }
}
.mbf-sweep {
  animation: mbf-sweep 1.2s linear infinite;
}

.mbf-breathe {
  animation: mbf-breathe 1.6s ease-in-out infinite;
  transform-origin: center;
}

.mbf-pulse {
  animation: mbf-pulse 1.8s cubic-bezier(0.2, 0.8, 0.2, 1) 3;
}

.mbf-shimmer {
  background: linear-gradient(90deg, #f3f1eb 0%, #e8e5dc 50%, #f3f1eb 100%);
  background-size: 200% 100%;
  animation: mbf-shimmer 1.2s linear infinite;
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/main.scss","webpack://./src/styles/mixins.scss"],"names":[],"mappings":"AAIA;EACE,eAAA;AAHF;ACuBE;EDrBF;IAII,eAAA;EAFF;AACF;ACwBE;ED3BF;IAQI,iBAAA;EADF;AACF;ACyBE;EDjCF;IAYI,eAAA;EAAF;AACF;ACyBE;EDtCF;IAgBI,eAAA;EACF;AACF;;AAEA;EACE,mCAAA;EACA,kCAAA;EACA,kCAAA;AACF;;AAOA;EACE;IACE,4BAAA;EAJF;EAMA;IACE,4BAAA;EAJF;AACF;AAQA;EACE;IAEE,sBAAA;IACA,aAAA;EAPF;EASA;IACE,sBAAA;IACA,UAAA;EAPF;AACF;AAWA;EACE;IACE,kEAAA;EATF;EAWA;IACE,iEAAA;EATF;AACF;AAaA;EACE;IACE,4BAAA;EAXF;EAaA;IACE,2BAAA;EAXF;AACF;AAcA;EACE,yCAAA;AAZF;;AAeA;EACE,gDAAA;EACA,wBAAA;AAZF;;AAgBA;EACE,0DAAA;AAbF;;AAgBA;EACE,yEAAA;EACA,0BAAA;EACA,2CAAA;AAbF;;AAmBA;EACE;;;IAGE,qCAAA;IACA,uCAAA;IACA,sCAAA;IACA,gCAAA;EAhBF;AACF","sourcesContent":["@use \"./mixins.scss\" as *;\n\n// Root font-size drives every Chakra rem token (sidebar width, type scale, spacing).\n// Floor raised to 13px on phones; laptop/desktop unchanged.\n:root {\n  font-size: 13px; // xs + sm\n\n  @include md {\n    font-size: 14px;\n  }\n\n  @include lg {\n    font-size: 14.5px;\n  }\n\n  @include xl {\n    font-size: 15px;\n  }\n\n  @include xxl {\n    font-size: 16px;\n  }\n}\n\nhtml {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-rendering: optimizeLegibility;\n}\n\n// ---------------------------------------------------------------------------\n// Signature keyframes (used by BrandSplash, StatusBadge and any page that opts in via className)\n// ---------------------------------------------------------------------------\n\n// BrandSplash: 48px green segment sweeping across a 160px track\n@keyframes mbf-sweep {\n  from {\n    transform: translateX(-48px);\n  }\n  to {\n    transform: translateX(160px);\n  }\n}\n\n// BrandSplash: logo breathing\n@keyframes mbf-breathe {\n  0%,\n  100% {\n    transform: scale(0.98);\n    opacity: 0.85;\n  }\n  50% {\n    transform: scale(1.02);\n    opacity: 1;\n  }\n}\n\n// StatusBadge dot pulse (reorder / in progress). Colour comes from --mbf-pulse-rgb (\"r,g,b\").\n@keyframes mbf-pulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(var(--mbf-pulse-rgb, 107, 191, 89), 0.45);\n  }\n  100% {\n    box-shadow: 0 0 0 6px rgba(var(--mbf-pulse-rgb, 107, 191, 89), 0);\n  }\n}\n\n// Skeleton / bar shimmer for custom loaders\n@keyframes mbf-shimmer {\n  from {\n    background-position: -200% 0;\n  }\n  to {\n    background-position: 200% 0;\n  }\n}\n\n.mbf-sweep {\n  animation: mbf-sweep 1.2s linear infinite;\n}\n\n.mbf-breathe {\n  animation: mbf-breathe 1.6s ease-in-out infinite;\n  transform-origin: center;\n}\n\n// Three beats then rest: badges sit in tables that are read, so no infinite loop (spec §10, WCAG 2.2.2).\n.mbf-pulse {\n  animation: mbf-pulse 1.8s cubic-bezier(0.2, 0.8, 0.2, 1) 3;\n}\n\n.mbf-shimmer {\n  background: linear-gradient(90deg, #f3f1eb 0%, #e8e5dc 50%, #f3f1eb 100%);\n  background-size: 200% 100%;\n  animation: mbf-shimmer 1.2s linear infinite;\n}\n\n// ---------------------------------------------------------------------------\n// Reduced motion — CSS layer (the JS layer is useReducedMotion() from theme/foundations/motion)\n// ---------------------------------------------------------------------------\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n  }\n}\n","@use \"sass:map\";\n\n$breakpoints: (\n  \"xs\": 0px,\n  \"sm\": 30em,\n  \"md\": 48em,\n  \"lg\": 62em,\n  \"xl\": 80em,\n  \"xxl\": 96em,\n);\n$screenSizes: sm, md, lg, xl, xxl;\n\n@mixin xs {\n  @media (min-width: map.get($breakpoints, \"xs\")) {\n    @content;\n  }\n}\n\n@mixin sm {\n  @media (min-width: map.get($breakpoints, \"sm\")) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (min-width: map.get($breakpoints, \"md\")) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (min-width: map.get($breakpoints, \"lg\")) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (min-width: map.get($breakpoints, \"xl\")) {\n    @content;\n  }\n}\n@mixin xxl {\n  @media (min-width: map.get($breakpoints, \"xxl\")) {\n    @content;\n  }\n}\n\n@mixin screen-size($size) {\n  @if ($size == sm) {\n    @include sm {\n      @content;\n    }\n  } @else if ($size == md) {\n    @include md {\n      @content;\n    }\n  } @else if ($size == lg) {\n    @include lg {\n      @content;\n    }\n  } @else if ($size == xl) {\n    @include xl {\n      @content;\n    }\n  } @else if ($size == xxl) {\n    @include xxl {\n      @content;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
